import React from 'react';
import { useHistory } from 'react-router-dom';
import connectUser from '../connectUser';
import SectionHeader from '../ui/SectionHeader';
import CategoryChip from '../ui/CategoryChip';
import AppCard from '../ui/AppCard';
import AppTile from '../ui/AppTile';
import HiveButton from '../ui/HiveButton';
import { populatedCategories, popularApps, recommendedApps, installedApps, accessState } from '../registry/selectors';
import './screens.css';

function HiveHome({ userInfo }) {
  const history = useHistory();
  const routes = userInfo?.routes ? [...userInfo.routes] : [];

  const cats = populatedCategories(routes);
  const popular = popularApps(routes);
  const recommended = recommendedApps(routes).slice(0, 8);
  const mine = installedApps(routes);
  const firstName = userInfo?.firstname;

  const openDetail = (app) => history.push(`/apps/${app.id}`);

  return (
    <div className="hive-container hive-screen">
      {/* Hero */}
      <section className="hive-hero hive-honeycomb-bg hive-rise">
        <div className="hive-hero-copy">
          <h1 className="hive-hero-title">
            Welcome{firstName ? `, ${firstName}` : ''} to<br />
            BeeNexa <span className="hive-gold-text">Hive</span>
          </h1>
          <p className="hive-hero-sub">Your business. All in one place.</p>
          <HiveButton variant="gold" onClick={() => history.push('/store')}>
            Explore Apps
          </HiveButton>
        </div>
        <div className="hive-hero-art" aria-hidden="true">
          <span className="hive-hero-hex hive-hero-hex-1" />
          <span className="hive-hero-hex hive-hero-hex-2" />
          <span className="hive-hero-hex hive-hero-hex-3" />
        </div>
      </section>

      {/* Categories */}
      <section className="hive-screen-section">
        <SectionHeader title="Categories" actionLabel="View all" onAction={() => history.push('/categories')} />
        <div className="hive-cat-rail hive-scroll">
          {cats.map((c) => (
            <CategoryChip key={c.id} category={c} onClick={() => history.push(`/store/category/${c.id}`)} />
          ))}
        </div>
      </section>

      {/* Popular Apps */}
      <section className="hive-screen-section">
        <SectionHeader title="Popular Apps" actionLabel="View all" onAction={() => history.push('/store')} />
        <div className="hive-card-list">
          {popular.map((app) => (
            <AppCard key={app.id} app={app} onView={() => openDetail(app)} />
          ))}
        </div>
      </section>

      {/* My Apps */}
      {mine.length > 0 && (
        <section className="hive-screen-section">
          <SectionHeader title="My Apps" actionLabel="View all" onAction={() => history.push('/my-apps')} />
          <div className="hive-tile-grid">
            {mine.map((app) => (
              <AppTile key={app.id} app={app} state="open" onClick={() => history.push(app.path)} />
            ))}
          </div>
        </section>
      )}

      {/* Recommended */}
      {recommended.length > 0 && (
        <section className="hive-screen-section">
          <SectionHeader title="Recommended for you" actionLabel="View all" onAction={() => history.push('/store')} />
          <div className="hive-tile-grid">
            {recommended.map((app) => (
              <AppTile
                key={app.id}
                app={app}
                state={accessState(app, routes)}
                onClick={() => openDetail(app)}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default connectUser(HiveHome);
